import {
  CONVERSION_FACTORS,
  UNIT_LABELS,
} from "@constants/priceRangeConstants";

export function formatInputValue(value: number): string {
  if (value >= CONVERSION_FACTORS.CRORE) {
    return (value / CONVERSION_FACTORS.CRORE).toFixed(1);
  } else if (value >= CONVERSION_FACTORS.LAKH) {
    return (value / CONVERSION_FACTORS.LAKH).toFixed(1);
  } else {
    return (value / CONVERSION_FACTORS.THOUSAND).toFixed(0);
  }
}

// Parse input value back to number
export function parseInputValue(inputValue: string, unit: string): number {
  const numericValue = parseFloat(inputValue);
  if (isNaN(numericValue)) return 0;

  switch (unit) {
    case UNIT_LABELS.CRORE:
      return Math.round(numericValue * CONVERSION_FACTORS.CRORE);
    case UNIT_LABELS.LAKH:
      return Math.round(numericValue * CONVERSION_FACTORS.LAKH);
    case UNIT_LABELS.THOUSAND:
      return Math.round(numericValue * CONVERSION_FACTORS.THOUSAND);
    default:
      return Math.round(numericValue);
  }
}
